const ufeApi = require('services/api/ufeApi');


// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+Shipping+Addresses+from+Profile+API


function getShippingAddresses(profileId) {
    const url = `/api/users/profiles/${profileId}/addresses`;
    return ufeApi.makeRequest(url, { method: 'GET' }).then(data => data.errorCode ? Promise.reject(data) : data);
}


module.exports = getShippingAddresses;
